/** SP3 §6/§7 — the client accept gate (server re-checks authoritatively). */
import type { BalanceSnapshot } from "@capture/shared";

export function canAcceptTransaction(input: {
  verdict: BalanceSnapshot["verdict"];
  overridden: boolean;
  allocationConfigured: boolean;
  allocationRemainderCents: number;
}): boolean {
  const balanced = input.verdict === "balanced" || input.overridden;
  if (!balanced) return false;
  if (input.allocationConfigured && input.allocationRemainderCents !== 0) return false;
  return true;
}
